<template>
  <div class="container">
    <h1 class="py-4">おたすけ返済予実情報詳細</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.advance_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">アプリユーザID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.application_user_id }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.advance_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.advance_amount }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替元金</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.advance_capital }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.advance_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">精算ステータス</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.settlement_status }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算予定日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_scheduled_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算開始日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_start_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算手段</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_method }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算完了日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_end_date }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth ht100 flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">予備</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.other }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "OtasukeForecastDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      advanceId: "",
      show: false,
      loading: true,
      data: [],
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.advanceId = this.$route.query.advanceId.toString();
    this.loadData();
  },
  methods: {
    init() {
      this.show = false;
      this.key = this.key ? 0 : 1;
    },
    async loadData() {
      this.init();
      const doc = await this.db
        .collection("otasukeForecast")
        .doc(this.advanceId)
        .get();
      if (doc.exists) {
        this.data = doc.data();

        let settlementMethodText = this.settlementMethodOptions.find((e) => {
          return e.value == this.data.settlement_method;
        });
        if (settlementMethodText !== undefined) {
          this.data.settlement_method = settlementMethodText.display;
        }
        
        let settlementStatusText = this.settlementOptions.find((e) => {
          return e.value == this.data.settlement_status;
        });
        if (settlementStatusText !== undefined) {
          this.data.settlement_status = settlementStatusText.display;
        }
        this.show = true;
        this.loading = false;
      }
    },
  },
};
</script>
